module.exports = __webpack_public_path__ + "img/newstop.f8115dab.png";